<template>
  <div class="wrapper-page contacts-index">
    <import ref='import'/>
    <contact-form ref='contactForm' @success='loadContacts()' />
    <bulk-add-folders-modal ref="bulkAddFoldersModal" @success="loadContacts()" />

    <div class="container-fluid text-center">
      <h1 class="page-title">{{$t('contacts.contacts')}}</h1>
      <div class="clearfix"></div>
      <a href="#" class="btn btn-primary float-right" @click.prevent="$refs.contactForm.open(contact)">{{$t('contacts.add_new')}}</a>
      <a href="#" class="btn btn-outline-primary float-right m-r-10" @click.prevent="$refs.import.open">{{$t('contacts.import_contacts')}}</a>

      <div class="clearfix m-b-10"></div>

      <filter-list />

      <div class="btn-group float-right show-hide-columns" role="group"  v-click-outside="closeDropdown">
        <button class="btn btn-neutral dropdown-toggle" v-on:click="openDropdown = !openDropdown">
          {{$t('contacts.show_hide_columns')}}
        </button>

        <ul class="dropdown-menu" v-if="openDropdown">
          <li class="dropdown-item" @click="toggleColumns('name')">
            <input type="checkbox" :checked="showName" />
            {{$t('contacts.show_hide_contact_name')}}
          </li>
          <li class="dropdown-item" @click="toggleColumns('email')">
            <input type="checkbox" :checked="showEmail" />
            {{$t('contacts.show_hide_contact_email')}}
          </li>
          <li class="dropdown-item" @click="toggleColumns('company')">
            <input type="checkbox" :checked="showCompany" />
            {{$t('contacts.show_hide_company')}}
          </li>
          <li class="dropdown-item" @click="toggleColumns('communication')">
            <input type="checkbox" :checked="showCommunication" />
            {{$t('contacts.show_hide_contact_communication')}}
          </li>
          <li class="dropdown-item" @click="toggleColumns('tags')">
            <input type="checkbox" :checked="showTags" />
            {{$t('contacts.show_hide_contact_tags')}}
          </li>
          <li class="dropdown-item" @click="toggleColumns('records')">
            <input type="checkbox" :checked="showRecords" />
            {{$t('contacts.show_hide_contact_record_count')}}
          </li>
          <li class="dropdown-item" @click="toggleColumns('checklist')">
            <input type="checkbox" :checked="showChecklist" />
            {{$t('contacts.show_hide_contact_checklist')}}
          </li>
          <li class="dropdown-item" @click="toggleColumns('created_at')">
            <input type="checkbox" :checked="showCreatedAt" />
            {{$t('contacts.show_hide_contact_created_at')}}
          </li>
          <li class="dropdown-item" @click="toggleColumns('actions')">
            <input type="checkbox" :checked="showActions" />
            {{$t('contacts.show_hide_contact_actions')}}
          </li>
          <li>
            <button class="btn btn-primary float-right m-r-10" v-on:click="openDropdown = false">
              {{$t('contacts.edit_modal.save')}}
            </button>
          </li>
        </ul>
      </div>

      <filter-list-from-params />

      <loading v-if="loading" class="m-t-60" />

      <div class="empty-list-wrapper" v-else-if="!contacts.length > 0 && !hasFilters">
        <img src="../assets/empty_states/contacts.png" alt="contact"/>
        <p>{{$t('contacts.no_contacts')}}</p>
      </div>

      <div class="empty-list-wrapper" v-else-if='hasFilters && contacts.length === 0'>
        <img src="../assets/empty_states/records.png" alt="files"/>
        <p>{{ $t('root.no_data_filters') }}</p>
        <router-link :to='{ query: {} }'>
          {{ $t('root.clear_filters') }}
        </router-link>
      </div>

      <div class="table_wrapper" v-else>
        <div class='bulk-container' v-show='bulkOpContacts.length > 0'>
          <span>{{ bulkOpContacts.length }} {{ $t('contacts.bulk_contacts') }}</span>

          <ul>
            <li>
              <a  href='#' class="dropdown-item"  @click.prevent="$refs.bulkTagModal.openContacts(bulkOpContacts)">
                <i class="fas fa-tag"></i>
                {{ $t('folder_show.add_tags') }}
              </a>
              <bulk-tag-modal ref="bulkTagModal" @success="loadContacts()"/>
            </li>
            <li>
              <a  href='#' class="dropdown-item"  @click.prevent="$refs.bulkAddFoldersModal.open(bulkOpContacts)">
                <i class="fas fa-plus"></i>
                {{ $t('contacts.add_folder') }}
              </a>
            </li>
          </ul>
        </div>

        <table class="table">
          <thead>
          <tr>
            <th>
              <input type="checkbox" @input="selectAll" />
            </th>
            <th v-if="showName">
              <router-link :to="addToQuery({ 'filters[s]': sortBy('name') })">
                {{$t('contacts.table_headers.name')}}
                <span :class="classSortDirection('name')"></span>
              </router-link>
            </th>
            <th v-if="showEmail">{{$t('contacts.table_headers.email')}}</th>
            <th v-if="showCompany">
              <router-link :to="addToQuery({ 'filters[s]': sortBy('company') })">
                {{$t('contacts.table_headers.company')}}
                <span :class="classSortDirection('company')"></span>
              </router-link>
            </th>
            <th v-if="showCommunication">{{$t('contacts.table_headers.communication')}}</th>
            <th v-if="showTags">{{$t('contacts.table_headers.tags')}}</th>
            <th v-if="showRecords">{{$t('contacts.table_headers.records')}}</th>
            <th v-if="showChecklist">{{$t('contacts.table_headers.checklist')}}</th>
            <th v-if="showCreatedAt">{{$t('contacts.table_headers.created_at')}}</th>
            <th v-if="showActions">{{$t('contacts.table_headers.actions')}}</th>
          </tr>
          </thead>
          <tbody name="fade" is="transition-group">
            <tr v-for="c in contacts" :key='c.id'>
              <td class="bulk-check">
                <input type="checkbox" v-model="bulkOpContacts" :value='c' />
              </td>
              <td v-if="showName">
                <router-link :to="{name: 'contact_folders', params: {id: c.id}}">
                  {{c.name}}<br/>
                </router-link>
              </td>

              <td v-if="showEmail">
                <router-link :to="{name: 'contact_folders', params: {id: c.id}}">
                  <span v-if='c.email'>
                    {{ c.email}}
                  </span>
                  <span v-else class='red-text'>
                    {{$t('contacts.no_email_added')}}
                  </span>
                </router-link>
              </td>

              <td v-if="showCompany">
                <router-link :to="{name: 'contact_folders', params: {id: c.id}}">
                  <span v-if='c.company'>
                    {{ c.company}}
                  </span>
                  <span v-else>
                    {{$t('contacts.no_contact_added')}}
                  </span>
                </router-link>
              </td>

              <td class="com-status" v-if="showCommunication">
                <router-link :to="{name: 'contact_communications', params: {id: c.id}}" class='own-tooltip own-tooltip-right' :data-tooltip='lastMessageAlt(c.contact_data)'>
                  <img v-if='c.contact_data' :src="require(`../assets/${c.contact_data.status}-env.png`)" />
                </router-link>
              </td>

              <td class='tags-cont' v-if="showTags">
                <tag-manager resourceType='contact' :resource="c" v-on:reload-list="loadContacts()" />
                <div class="tag-dropdown-column">
                  <div class="existing-tags-wrapper" :class="tag.color" v-for="tag in c.tags" :key='tag.id'>
                    <div class="btn-group btn-group-toggle" data-toggle="buttons">
                      <label class="btn active">
                        <router-link :to="{name: 'tag', params: { id: tag.id }}">
                          {{tag.name}}
                        </router-link>
                      </label>

                      <label class="btn" @click.prevent="removeConnectedTag(tag, c.id)">
                        <i class="fas fa-times"></i>
                      </label>
                    </div>
                  </div>
                </div>
              </td>

              <td v-if="showRecords">
                {{recordsCount(c)}}
              </td>

              <td v-if="showChecklist">
                <checklist-status :items-count='checklistItems(c)' :completed-items-count='checklistItemsChecked(c)' />
              </td>

              <td v-if="showCreatedAt">
                {{formatDate(c.created_at)}}
              </td>

              <td class='actions' v-if="showActions">
                <ul>
                  <li :title="$t('contacts.edit_modal.edit')">
                    <a href="#" @click.prevent="$refs.contactForm.open(c)">
                      <i class='fas fa-edit'></i>
                    </a>
                  </li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="clearfix"></div>
      <pagination :meta='meta' />
    </div>
  </div>
</template>

<script>
  import _modal from '../components/_modal'
  import _loading from '../components/_loading'
  import _pagination from '../components/_pagination'
  import _user_image from '../components/_user_image'
  import _import from '../components/contacts/_import'
  import tag_manager from "../components/tags/_tags_manager"
  import _pink_cat_select from '../components/shared/PinkCatSelect'
  import checklistStatus from '../components/contacts/_checklist_status'
  import _contact_form from '../components/shared/contacts/_contact_form'

  import _bulk_tag_items_modal from '../components/shared/items/_bulk_tag_items_modal'
  import _bulk_add_folders_modal from '../components/contacts/_bulk_add_folders_modal'

  import _filter_list from '../components/filters/contacts/_filter_list_for_contact_index'
  import _filter_list_from_params from '../components/filters/contacts/_filter_list_from_params';

  export default {
    components: {
      modal: _modal,
      'import': _import,
      'loading': _loading,
      pagination: _pagination,
      'user-image': _user_image,
      'tag-manager': tag_manager,
      'pink-cat-select': _pink_cat_select,
      'checklist-status': checklistStatus,
      'contact-form': _contact_form,

      'bulk-tag-modal': _bulk_tag_items_modal,
      'bulk-add-folders-modal': _bulk_add_folders_modal,

      'filter-list': _filter_list,
      'filter-list-from-params': _filter_list_from_params
    },
    watch: {
      query() {
        this.loadContacts()
      }
    },
    created() {
      this.listStore.getContacts()
      this.loadContacts()
      this.store.sendMetrics({name: 'contacts', params: this.$route.params, path: this.$route.fullPath})
    },
    data() {
      return {
        openDropdown: false,
        loading: false,
        bulkOpContacts: []
      }
    },
    computed: {
      contacts() {
        return this.state.contacts || []
      },
      folderStats() {
        return this.stats.folders || []
      },
      contactColumns() {
        return new Set((this.userDefaults.contact || []))
      },
      showName() {
        return this.contactColumns.has('name')
      },
      showEmail() {
        return this.contactColumns.has('email')
      },
      showCompany() {
        return this.contactColumns.has('company')
      },
      showCommunication() {
        return this.contactColumns.has('communication')
      },
      showTags() {
        return this.contactColumns.has('tags')
      },
      showActions() {
        return this.contactColumns.has('actions')
      },
      showChecklist() {
        return this.contactColumns.has('checklist')
      },
      showCreatedAt() {
        return this.contactColumns.has('created_at')
      },
      showRecords() {
        return this.contactColumns.has('records')
      },
      columnsSize() {
        return this.contactColumns.size === 0
      }
    },
    methods: {
      loadContacts() {
        const params = Object.assign({}, this.query)

        this.loading = true
        this.store.getContacts(params).then(() => {
          this.loading = false
          const contactIds = this.contacts.map(c => c.id)
          this.statStore.getFolders({ 'filters[contact_id]': contactIds })
        })
        this.bulkOpContacts = []
      },
      foldersOfContact(contact) {
        return this.folderStats.filter(f => f.contact_id == contact.id)
      },
      closeDropdown() {
        this.openDropdown = false
      },
      checklistItems(contact) {
        return this.foldersOfContact(contact).reduce((s, f) => s + f.total_checklist_items, 0)
      },
      checklistItemsChecked(contact) {
        return this.foldersOfContact(contact).reduce((s, f) => s + f.checked_checklist_items, 0)
      },
      lastMessageAlt(contactData) {
        if (!contactData)
          return

        const d = this.formatDate(contactData.last_communication_at)
        const t = this.formatTime(contactData.last_communication_at)

        switch (contactData.status) {
          case 'gray':
            return this.$t('contacts.no_sent_message')
          case 'yellow':
            return this.$t('contacts.sending_message', { date: d, time: t })
          case 'red':
            return this.$t('contacts.message_not_sent', { date: d, time: t })
          case 'green':
            return this.$t('contacts.message_sent', { date: d, time: t })
        }
      },
      removeConnectedTag(tag, contact_id) {
        this.store.removeConnectedTag(tag.id, {contact_id: contact_id}).then(() => {
          this.store.sendMetrics({name: 'remove_tag_from_contact', params: this.$route.params, path: this.$route.fullPath})
          this.loadContacts()
        })
      },
      toggleColumns(column) {
        const newContactColumns = this.contactColumns

        this.contactColumns.has(column) ? newContactColumns.delete(column) : newContactColumns.add(column)

        const newDefaults = Object.assign({}, this.currentUser.defaults, { contact: Array.from(newContactColumns) })

        this.store.updateUserProfile({ user: { defaults: newDefaults } }).then(() => {
          this.store.getCurrentUser()
        })
      },
      recordsCount(contact) {
        return this.foldersOfContact(contact).reduce((s, f) => s + f.records_count, 0)
      },
      saveColumns() {
        this.openDropdown = !this.openDropdown
      },
      selectAll(e) {
        this.bulkOpContacts = e.target.checked ? this.contacts : []
      }
    }
  }
</script>
<style lang="sass">
  @import "../styles/contact"
  @import '../styles/checklists'
  .contacts-index
    h1
      text-align: left
    .table_wrapper
      margin-top: 30px
    .filter-results p
      max-width: 100px
      overflow: hidden
      text-overflow: ellipsis
      display: inline
  .bulk-container
    ul
      margin-top: 0
</style>
